import { TPictoName } from "@amphore-dev/amphore-lib";

import { TOnboardingStep } from "@/types";

/** Step order — also the progress denominator. */
export const ONBOARDING_STEPS: TOnboardingStep[] = [
	"project",
	"rhythm",
	"company",
];

/**
 * The project is required: tasks cannot exist without one, and a new
 * account's view shows whatever it reaches (docs/modele.md, phase 6).
 */
export const ONBOARDING_OPTIONAL_STEPS: TOnboardingStep[] = [
	"rhythm",
	"company",
];

export const ONBOARDING_STEP_PICTOS: Record<TOnboardingStep, TPictoName> = {
	rhythm: "clock",
	company: "briefcase",
	project: "folder",
};

export const ONBOARDING_MAX_WIDTH_CLASS = "max-w-[720px]";
